// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__neEfE","footer":"ModalError_footer__xiIat"};